import FreeTrialContainers from "./containers/FreeTrialContainers";
import "./SCSS/styles.scss";
export default FreeTrialContainers;
